import React, { FC } from "react";

import { FormControl, InputLabel, MenuItem, Select, TextFieldProps } from "@mui/material";

const commonInputPtops: Pick<TextFieldProps, "sx" | "size" | "InputLabelProps"> = {
  size: "small",
  InputLabelProps: { shrink: true },
  sx: { ".MuiInputBase-root": { borderRadius: "8px" } }
};

interface DateRangeSelectorProps {
  value: number;
  onChange: (value: number) => void;
}

export const DateRangeSelector: FC<DateRangeSelectorProps> = ({ value, onChange }) => {
  return (
    <FormControl {...commonInputPtops} sx={{ width: 167 }}>
      <InputLabel id="date-range-label">Date Range</InputLabel>
      <Select
        sx={{
          ".MuiSelect-select": {
            padding: "8.5px 10px !important"
          },
          borderRadius: "8px"
        }}
        value={value}
        label="Date Range"
        onChange={(e) => onChange(Number(e.target.value))}
      >
        <MenuItem value={-1} disabled={true}>
          Select Range
        </MenuItem>
        <MenuItem value={1}>Today</MenuItem>
        <MenuItem value={2}>Last 2 days</MenuItem>
        <MenuItem value={3}>Last 3 days</MenuItem>
        <MenuItem value={4}>Last 4 days</MenuItem>
        <MenuItem value={5}>Last 5 days</MenuItem>
        <MenuItem value={7}>One week</MenuItem>
        <MenuItem value={14}>Two weeks</MenuItem>
        <MenuItem value={30}>One month</MenuItem>
      </Select>
    </FormControl>
  );
};
